import { gql } from "@apollo/client";

export const GET_PROTECTION_PLAN = gql`
  query protectionPlan($id: ID!) {
    protectionPlan(id: $id) {
      id
      name
      description
      excess
      code
    }
  }
`;
